import initMenu from "./modules/menu";
import './modules/hash';
import './modules/aos';
import './modules/counter';
import './modules/fancybox';
import './modules/accordion';
import './modules/galleryCarousel';
import './modules/logosCarousel';
import './modules/testimonialsCarousel';
import './modules/podcastListing';
import './modules/organizations';
import './modules/front-page';
import './modules/team';
import './modules/resources';
import './modules/newsletterForm';

import '../scss/theme.scss';

jQuery(document).ready( function($) {
    initMenu();
});